import React from 'react';
import { Alert, Box, Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';

export const PageHeader = ({ title, subtitle = '', actions = null }) => (
  <Paper
    elevation={0}
    className="page-enter surface-hover"
    sx={{
      p: { xs: 1.5, md: 2 },
      mb: 2,
      borderRadius: 'var(--ui-radius-md)',
      border: '1px solid var(--ui-border)',
      boxShadow: 'var(--ui-shadow-sm)',
      background: 'linear-gradient(135deg, var(--ui-surface) 0%, var(--ui-surface-soft) 100%)',
    }}
  >
    <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', md: 'center' }} spacing={1.2}>
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 700, lineHeight: 1.15 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions ? <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>{actions}</Stack> : null}
    </Stack>
  </Paper>
);

export const LoadingPane = ({ label = 'Loading...' }) => (
  <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mt={6} gap={1}>
    <CircularProgress />
    <Typography variant="body2" color="text.secondary">{label}</Typography>
  </Box>
);

export const ErrorBanner = ({ message }) =>
  message ? (
    <Alert severity="error" sx={{ mb: 2 }}>
      {message}
    </Alert>
  ) : null;

export const EmptyPane = ({ title = 'No records found', subtitle = '', action = null }) => (
  <Paper
    variant="outlined"
    className="page-enter"
    sx={{
      p: 3,
      borderRadius: 'var(--ui-radius-md)',
      borderStyle: 'dashed',
      borderColor: 'var(--ui-border-strong)',
      textAlign: 'center',
      backgroundColor: 'var(--ui-surface)',
    }}
  >
    <Typography variant="h6" sx={{ mb: 0.8 }}>
      {title}
    </Typography>
    {subtitle ? (
      <Typography variant="body2" color="text.secondary" sx={{ mb: action ? 1.4 : 0 }}>
        {subtitle}
      </Typography>
    ) : null}
    {action ? <Button variant="contained" onClick={action.onClick}>{action.label}</Button> : null}
  </Paper>
);
